// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"_93444fe79c--checkbox--l9NIC","label":"_93444fe79c--label--wg3E4","box":"_93444fe79c--box--LEKeq","hasLabel":"_93444fe79c--hasLabel--uSvdq"};